import * as React from 'react';

import * as ReactDOM from 'react-dom';

import UnsavedChangesDialog from 'common/components/UnsavedChangesDialog/UnsavedChangesDialog';

/**
 * The function that renders the unsaved changes dialog that prevents the navigation.
 */
export default function unsavedChangesConfirmation(message: string, callback: (ok: boolean) => void) {
  // Add a container for the dialog to the DOM.
  const dialogContainer = document.createElement('div');
  dialogContainer.setAttribute('id', 'unsaved-changes-dialog-container');
  document.body.appendChild(dialogContainer);

  // The func that cleans up the DOM modifications and calls the given callback with the given answer.
  const resolve = (answer: boolean) => {
    ReactDOM.unmountComponentAtNode(dialogContainer);
    document.body.removeChild(dialogContainer);
    callback(answer);
  };

  // Render the UnsavedChangesDialog in the created container.
  ReactDOM.render(
    <UnsavedChangesDialog confirm={() => resolve(true)} onClose={() => resolve(false)} isOpen={true} />,
    dialogContainer
  );
}
